/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Email_Enabled_LabelInputs */

const he_account_delivery_email_enabled_label = /** @type {(inputs: Account_Delivery_Email_Enabled_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות באימייל`)
};

const en_account_delivery_email_enabled_label = /** @type {(inputs: Account_Delivery_Email_Enabled_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email notifications`)
};

/**
* | output |
* | --- |
* | "Email notifications" |
*
* @param {Account_Delivery_Email_Enabled_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_email_enabled_label = /** @type {((inputs?: Account_Delivery_Email_Enabled_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Email_Enabled_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_email_enabled_label(inputs)
	return en_account_delivery_email_enabled_label(inputs)
});